import { render, staticRenderFns } from "./TiersHistorique.vue?vue&type=template&id=71b70292&"
import script from "./TiersHistorique.vue?vue&type=script&lang=js&"
export * from "./TiersHistorique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports